export const AUCTION_SOCKET_EVENTS = {
  publish: 'premium.AUCTION_PUBLISH',
  withdraw: 'premium.AUCTION_WITHDRAW',
  inPrepare: 'premium.AUCTION_IN_PREPARE',
  hidden: 'premium.AUCTION_HIDDEN',
  finished: 'premium.AUCTION_FINISH',
  visible: 'premium.AUCTION_VISIBLE',
  hotbidStart: 'premium.AUCTION_START_HOTBID',
} as const
